import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeleteAllowListMemberFormModal from 'src/features/parkingManagement/components/AllowLists/forms/DeleteAllowListMemberFormModal';
import UpdateAllowListMemberFormModal from 'src/features/parkingManagement/components/AllowLists/forms/UpdateAllowListMemberFormModal';
import { allowListMessages } from 'src/features/parkingManagement/utils/allowListMessages';
import { ICON_MAP } from 'src/features/parkingStatus/utils';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/utils/messages';

import type { AllowListMember } from 'src/features/parkingManagement/types/allowList';

export default function CellAllowListMemberActions({ row }: CellContext<AllowListMember, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateAllowListMemberFormModal
                        semantics={{ entryName: formatMessage(allowListMessages.member) }}
                        selectedMember={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateAllowListMemberFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteAllowListMemberFormModal
                        selectedMember={row.original}
                        semantics={{ entryName: formatMessage(allowListMessages.member) }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteAllowListMemberFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
